// extracted by mini-css-extract-plugin
export default {"container":"AppReferencia_container__PxlSi","title":"AppReferencia_title__ukqYy","iamgen":"AppReferencia_iamgen__kZear","card":"AppReferencia_card__BBzmS"};